import { withParams, req } from 'vuelidate/lib/validators/common'
export * from 'vuelidate/lib/validators'

export const numAndLetter = withParams({ type: 'numAndLetter' }, value =>
  /^(?=.*[0-9])(?=.*[a-zA-Z])([0-9A-Za-z]{3,})$/i.test(value)
)
export const phone = withParams({ type: 'phone' }, value =>
  /^1[3-9]\d{9}$/.test(value)
)
export const equalTo = length =>
  withParams(
    { type: 'equalTo', length },
    value => !req(value) || (!/\s/.test(value) && value.length === length)
  )
export const noZero = withParams({ type: 'noZero' }, value => +value !== 0)

export const specialCharacter = withParams({ type: 'specialCharacter' }, value =>
  /^[\u4e00-\u9fa5a-zA-Z0-9]+$/.test(value)
)

export const noSpace = withParams({ type: 'noSpace' }, value =>
  !(/\s+/.test(value))
)

export const contactPhone = withParams({ type: 'contactPhone' }, value =>
  /^[0-9]{11}/.test(value)
)

export const userNickname = withParams({ type: 'userNickname' }, value =>
  /^[\u4e00-\u9fa5_a-zA-Z0-9]{1,20}$/.test(value)
)
export const userFullName = withParams({ type: 'userFullName' }, value =>
  value === '' || /^([\u4e00-\u9fa5]{2,15}|[a-zA-Z](\s?[a-zA-Z]){3,29})$/.test(value)
)
export const userQQ = withParams({ type: 'userQQ' }, value =>
  value === '' || /^\d{5,20}$/.test(value)
)
export const userDesc = withParams({ type: 'userDesc' }, value =>
  value.length <= 200
)
